export const VALID_IMAGE_TYPES = [
    { type: "image/png", extensions: [".png"] },
    { type: "image/jpeg", extensions: [".jpg", ".jpeg"] },
    { type: "image/jpg", extensions: [".jpg"] },
    { type: "image/gif", extensions: [".gif"] },
    { type: "image/webp", extensions: [".webp"] }
];
export const CANVAS_SELECTORS = {
    EXCALIDRAW_CANVAS: '.excalidraw__canvas',
    EXCALIDRAW_CONTAINER: '.excalidraw',
    EXPORT_BUTTON: '[data-testid="image-export-button"]'
};
export const CURSOR_STATES = {
    GRAB: 'grab',
    GRABBING: 'grabbing',
    DEFAULT: 'default'
};
export const TOOL_CONFIG = {
    SELECTION: {
        type: 'selection',
        locked: false
    },
    FREEDRAW: {
        type: 'freedraw',
        locked: false
    },
    ERASER: {
        type: 'eraser',
        locked: false
    },
    ELLIPSE: {
        type: 'ellipse',
        locked: false
    },
    RECTANGLE: {
        type: 'rectangle',
        locked: false
    },
    TEXT: {
        type: 'text',
        locked: false
    },
};
